// extracted by mini-css-extract-plugin
module.exports = {"content":"content-NOPSw","payment":"payment-2IN56","paymentIcon_failed":"paymentIcon_failed-YJyd9"};